module.exports = __webpack_public_path__ + "media/images/favicn/android-chrome-384x384-66a0ee75b73c63fdd221ac9bb9b7b96b.png";